import { filter } from "#shared/array.ts";
import { plan_cleanup } from "./editable_rows_logic.ts";
const editable_rows = ({ initial, make_empty_row, row_is_empty, get_key }) => {
  let rows = $state([...initial]);
  let focused_row_key = $state(null);
  const non_empty_rows = $derived(filter(rows, (row) => !row_is_empty(row)));
  const remove_empty_rows = () => {
    const { rows_to_keep } = plan_cleanup({ rows, row_is_empty, get_key, focused_row_key });
    if (rows_to_keep.length !== rows.length) {
      rows = rows_to_keep;
    }
  };
  $effect(() => {
    const { rows_to_keep, needs_new_empty_row } = plan_cleanup({ rows, row_is_empty, get_key, focused_row_key });
    if (needs_new_empty_row) {
      rows.push(make_empty_row());
      return;
    }
    if (rows_to_keep.length !== rows.length) {
      const timeout = setTimeout(remove_empty_rows, 0);
      return () => clearTimeout(timeout);
    }
  });
  const row_is_placeholder = (row) => {
    const last_row = rows[rows.length - 1];
    return last_row !== void 0 && get_key(row) === get_key(last_row) && row_is_empty(row);
  };
  return {
    get rows() {
      return rows;
    },
    get focused_row_key() {
      return focused_row_key;
    },
    set focused_row_key(key) {
      focused_row_key = key;
    },
    get non_empty_rows() {
      return non_empty_rows;
    },
    get_key,
    remove: (key) => {
      rows = filter(rows, (row) => get_key(row) !== key);
    },
    row_is_placeholder
  };
};
export default editable_rows;
